import React from 'react'

function UserAccountControl() {
  return (
    <div>UserAccountControl</div>
  )
}

export default UserAccountControl;